module.exports = __webpack_public_path__ + "media/images/shapes/angles/angle-top-right-f104eaf828fd441566a1f526818721b2.svg";